<template>
  <div>
    <encabezado-component
      :usuario="usuario"
      :permisos="sesion.permisos()"
      :tema="tema"
      @cierre="olvidarSesion"
      @cambiar-tema="cambiarTema"
    />
    <div :class="{ 'container': usuario }">
      <router-view @sesion="obtenerUsuario" />
    </div>
  </div>
</template>

<script>
  import EncabezadoComponent from './components/EncabezadoComponent'
  import HttpService from './Servicios/HttpService'
  import AyudanteSesion from './Servicios/AyudanteSesion'

  export default {
    name: 'App',
    components: { EncabezadoComponent },

    data: () => ({
      usuario: null,
      permisos: null,
      sesion: AyudanteSesion,
      tema: 'dark',
    }),

    mounted() {
      this.obtenerUsuario()
      const temaGuardado = localStorage.getItem('sv-tema') || 'dark'
      this.tema = temaGuardado
      document.documentElement.setAttribute('data-theme', temaGuardado)
    },

    methods: {
      async obtenerUsuario() {
        const resultado = await HttpService.obtenerConConsultas('usuarios.php', {
          accion: 'estado_autenticacion'
        })
        if (!resultado) {
          AyudanteSesion.limpiarSesion()
          this.usuario = null
          this.permisos = null
          return
        }
        const { usuario, permisos } = resultado
        AyudanteSesion.setSesion(usuario, permisos)
        this.usuario = usuario
        this.permisos = typeof permisos === 'string' ? JSON.parse(permisos) : permisos
      },

      olvidarSesion() {
        AyudanteSesion.limpiarSesion()
        this.usuario = null
        this.permisos = null
        this.$router.push({ name: 'InicioSesionComponent' })
      },

      cambiarTema() {
        this.tema = this.tema === 'dark' ? 'light' : 'dark'
        document.documentElement.setAttribute('data-theme', this.tema)
        localStorage.setItem('sv-tema', this.tema)
      },

      extraerDatos() {
        return {
          usuario: this.usuario,
          permisos: this.permisos,
        }
      },
    },
  }
</script>
